import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';


@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body",
    templateUrl: "./aside-left-minimize-default-enabled.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideLeftMinimizeDefaultEnabledComponent implements OnInit {


    constructor() {

    }
    ngOnInit() {

    }

}


// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/planet-dev/src/app/theme/pages/aside-left-minimize-default-enabled/aside-left-minimize-default-enabled.component.ts